import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { TextFieldComponent } from '@src/suite/common/controls/text-field/text-field';
import { CurrencyMaskConfig } from 'ng2-currency-mask';

@Component({
    selector: 'st-text-field-currency',
    templateUrl: './text-field-currency.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'st-text-field-currency',
    },
})
export class TextFieldCurrencyComponent extends TextFieldComponent {
    public currencyMaskConfig: CurrencyMaskConfig = {
        align: 'left',
        allowNegative: false,
        decimal: '.',
        precision: 2,
        prefix: this.languageSettings.PSTWebCostCurrencyLabel,
        suffix: '',
        thousands: '',
    };
}
